<template>
    <span>
        <button :id="id" :dam_id="dam_id" :type="type" class="tiptap-inline-interactive-media-link btn btn-link align-baseline p-0">
            <font-awesome-icon v-if="media_type == 'pdf'" :icon="['fal', 'file-pdf']" fixed-width /> 
            <font-awesome-icon v-if="media_type == 'image'" :icon="['fal', 'file-image']" fixed-width /> 
            <font-awesome-icon v-if="media_type == 'video'" :icon="['fal', 'file-video']" fixed-width /> 
            <font-awesome-icon v-if="media_type == 'audio'" :icon="['fal', 'file-audio']" fixed-width /> 
            <span v-if="title">{{title}}</span><span v-else>{{formattedType(type)}}</span>
        </button>
    </span>
</template>

<style lang="scss">
.tiptap-inline-interactive-media-link {
    margin-top: -1px;
    margin-bottom: -1px;
    user-select: none;
    .blank-id {
        line-height: normal;
    }
}
</style>

<script>
export default {
    name: 'InteractiveMediaLink',
    props: ['node', 'updateAttrs', 'view'],
    components: {

    },
    computed: {
        id: {
            get () {
                return this.node.attrs.id
            },
            set (id) {
                // we cannot update `id` itself because `this.node.attrs` is immutable
                this.updateAttrs({
                    id
                })
            }
        },
        dam_id: {
            get () {
                return this.node.attrs.dam_id
            },
            set (dam_id) {
                this.updateAttrs({
                    dam_id
                })
            }
        },
        type: {
            get () {
                return this.node.attrs.type
            },
            set (type) {
                this.updateAttrs({
                    type
                })
            }
        },
        title: {
            get () {
                return this.node.attrs.title
            },
            set (title) {
                this.updateAttrs({
                    title
                })
            }
        },
        media_type: {
            get () {
                return this.node.attrs.media_type
            },
            set (media_type) {
                this.updateAttrs({
                    media_type
                })
            }
        },
    },
    methods: {
        formattedType (type) {
            if (type) {
                return type.replace(/_/g, " ")
            }
        }
    },
    mounted () {

    }
}
</script>
